'use client'

import 'swiper/scss'
import 'swiper/css/navigation'
import 'swiper/css/effect-coverflow'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules'
import s from './SliderPageThreeTest.module.scss'
import './SliderPageThreeTest.scss'
import { Button } from '@/shared/Button'
import { NextButton, PreviousButton } from '../MainSlider/Buttons/Buttons'
import { useMediaQuery } from 'usehooks-ts'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'next/navigation'
import Link from 'next/link'
import classNames from 'classnames'
import { useEffect, useState } from 'react'

export const FirstSlideSvg = ({ isMobile }: { isMobile: boolean }) => (
    <>
        {!isMobile ? (
            <svg
                width='269'
                height='203'
                viewBox='0 0 269 203'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M61.3235 169.461H134.194V199.47H0.5V190.938C29.6874 158.968 50.7455 135.137 63.6742 119.446C76.7987 103.559 85.5158 91.4971 89.8253 83.2594C94.1349 75.0217 96.2897 66.8821 96.2897 58.8406C96.2897 53.1527 95.0164 48.1512 92.4698 43.8362C90.1192 39.5213 86.6911 36.187 82.1857 33.8333C77.8761 31.2836 72.783 30.0087 66.9063 30.0087C57.6996 30.0087 50.2558 32.7546 44.575 38.2464C39.0901 43.542 36.3477 50.5048 36.3477 59.1348V63.5478H4.61367V59.1348C4.61367 41.4826 10.2944 27.2628 21.656 16.4754C33.0176 5.49179 48.003 0 66.6125 0C84.8302 0 99.6198 5.49179 110.981 16.4754C122.539 27.4589 128.317 41.5807 128.317 58.8406C128.317 67.8628 126.652 76.5908 123.322 85.0246C120.188 93.4585 113.724 104.344 103.929 117.681C94.3308 130.822 80.1288 148.082 61.3235 169.461Z'
                    fill='white'
                />
                <path
                    d='M200.037 74.1391C220.018 74.1391 236.374 80.2193 249.107 92.3797C262.036 104.54 268.5 119.741 268.5 137.981C268.5 156.614 262.134 172.109 249.401 184.465C236.668 196.822 220.801 203 201.8 203C182.995 203 167.324 197.116 154.787 185.348C142.446 173.58 135.981 158.575 135.394 140.335H167.128C167.519 149.945 170.947 157.791 177.412 163.871C183.876 169.951 192.006 172.991 201.8 172.991C211.79 172.991 220.018 169.657 226.482 162.988C233.142 156.32 236.472 147.984 236.472 137.981C236.472 134.647 235.983 131.411 235.003 128.272C234.22 125.134 233.044 122.29 231.477 119.741C229.91 116.995 227.951 114.543 225.6 112.386C223.446 110.228 220.997 108.365 218.255 106.796C215.512 105.227 212.476 104.05 209.146 103.265C206.012 102.481 202.584 102.088 198.862 102.088H142.996L143.327 97.6754L153.905 3.82464H254.984V32.6565H179.469L175.061 74.1391H200.037Z'
                    fill='white'
                />
            </svg>
        ) : (
            <svg
                width='160'
                height='121'
                viewBox='0 0 160 121'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M36.1577 100.739H79.4772V118.579H0V113.507C17.3511 94.5015 29.8694 80.335 37.5551 71.0073C45.3573 61.563 50.5393 54.3923 53.1012 49.4952C55.6631 44.5982 56.9441 39.7594 56.9441 34.979C56.9441 31.5977 56.1872 28.6244 54.6733 26.0593C53.2759 23.4942 51.238 21.5121 48.5597 20.1129C45.9978 18.5971 42.9701 17.8393 39.4766 17.8393C34.0034 17.8393 29.5783 19.4716 26.2013 22.7363C22.9407 25.8844 21.3104 30.0236 21.3104 35.1539V37.7773H2.44545V35.1539C2.44545 24.6602 5.8225 16.2069 12.5766 9.79411C19.3307 3.2647 28.2391 0 39.3019 0C50.1318 0 58.9237 3.2647 65.6778 9.79411C72.5484 16.3235 75.9837 24.7185 75.9837 34.979C75.9837 40.3424 74.9939 45.5309 73.0142 50.5446C71.151 55.5583 67.3081 62.0294 61.4856 69.9579C55.7796 77.7699 47.337 88.0304 36.1577 100.739Z'
                    fill='white'
                />
                <path
                    d='M118.619 44.0735C130.497 44.0735 140.22 47.688 147.789 54.917C155.475 62.146 159.318 71.1822 159.318 82.0257C159.318 93.1023 155.533 102.313 147.964 109.659C140.395 117.005 130.962 120.677 119.667 120.677C108.488 120.677 99.1716 117.18 91.7188 110.184C84.3824 103.188 80.5396 94.2683 80.1903 83.4248H99.0552C99.2881 89.1381 101.326 93.8019 105.169 97.4164C109.012 101.031 113.844 102.838 119.667 102.838C125.606 102.838 130.497 100.856 134.34 96.8917C138.299 92.9275 140.278 87.9721 140.278 82.0257C140.278 80.0435 139.987 78.1197 139.405 76.2541C138.939 74.3886 138.241 72.6979 137.309 71.1822C136.377 69.5498 135.213 68.0924 133.815 66.8098C132.535 65.5273 131.079 64.4196 129.449 63.4868C127.818 62.554 126.013 61.8545 124.034 61.3881C122.17 60.9217 120.133 60.6885 117.92 60.6885H84.7094L84.9065 58.0651L91.1948 2.27363H151.283V19.4133H106.392L103.771 44.0735H118.619Z'
                    fill='white'
                />
            </svg>
        )}
    </>
)

export const SecondSlideSvg = ({ isMobile }: { isMobile: boolean }) => (
    <>
        {!isMobile ? (
            <svg
                width='380'
                height='197'
                viewBox='0 0 380 197'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M80 74.8029C94.8571 77.4676 106.762 84.2246 115.714 95.0739C124.857 105.923 129.429 118.866 129.429 133.903C129.429 152.175 123.143 167.307 110.571 179.299C98.1904 191.1 82.6666 197 64 197C45.9047 197 30.8571 191.385 18.8571 180.155C7.04762 168.735 0.761905 154.079 0 136.187H30.8571C31.4286 145.704 34.7619 153.413 40.8571 159.313C46.9524 165.023 54.6666 167.878 64 167.878C73.9047 167.878 82.0952 164.643 88.5714 158.171C95.0476 151.509 98.2857 143.134 98.2857 133.046C98.2857 128.098 97.3333 123.529 95.4285 119.342C93.5238 114.964 90.9523 111.253 87.7142 108.207C84.4762 105.162 80.5714 102.878 76 101.355C71.4285 99.642 66.4762 98.7855 61.1428 98.7855H37.1428V92.7898L76.5714 31.6913H5.71428V3.7116H122V9.99276L80 74.8029Z'
                    fill='white'
                />
                <path
                    d='M184.143 164.452H255V193.574H125V185.294C153.381 154.269 173.857 131.143 186.428 115.916C199.19 100.499 207.667 88.7927 211.857 80.7985C216.048 72.8043 218.143 64.9053 218.143 57.1014C218.143 51.5816 216.905 46.728 214.428 42.5406C212.143 38.3531 208.809 35.1174 204.428 32.8333C200.238 30.3589 195.286 29.1217 189.571 29.1217C180.619 29.1217 173.381 31.7865 167.857 37.1159C162.524 42.2551 159.857 49.0121 159.857 57.3869V61.6696H129V57.3869C129 40.2565 134.524 26.457 145.571 15.9884C156.619 5.32947 171.19 0 189.286 0C207 0 221.381 5.32947 232.428 15.9884C243.667 26.6473 249.286 40.3517 249.286 57.1014C249.286 65.857 247.667 74.327 244.428 82.5116C241.381 90.6961 235.095 101.26 225.571 114.203C216.238 126.956 202.428 143.705 184.143 164.452Z'
                    fill='white'
                />
                <path
                    d='M288.177 133.081C280.754 133.081 274.653 130.756 269.874 126.106C265.196 121.457 262.857 115.493 262.857 108.216C262.857 101.039 265.196 95.177 269.874 90.6285C274.653 85.979 280.754 83.6543 288.177 83.6543C295.6 83.6543 301.651 85.979 306.328 90.6285C311.006 95.177 313.345 101.039 313.345 108.216C313.345 115.493 310.955 121.457 306.176 126.106C301.498 130.756 295.499 133.081 288.177 133.081ZM279.026 193.423L343.851 86.535H361.697L296.872 193.423H279.026ZM288.177 119.738C289.804 119.738 291.33 119.486 292.753 118.98C294.177 118.374 295.397 117.565 296.414 116.555C297.431 115.544 298.193 114.331 298.702 112.916C299.312 111.501 299.617 109.934 299.617 108.216C299.617 104.981 298.549 102.303 296.414 100.18C294.279 97.9566 291.533 96.8447 288.177 96.8447C284.923 96.8447 282.178 97.9566 279.941 100.18C277.805 102.303 276.738 104.981 276.738 108.216C276.738 111.551 277.805 114.331 279.941 116.555C282.178 118.677 284.923 119.738 288.177 119.738ZM372.831 186.752C368.154 191.3 362.154 193.575 354.833 193.575C347.511 193.575 341.461 191.3 336.682 186.752C332.004 182.102 329.665 176.189 329.665 169.013C329.665 161.837 332.004 155.974 336.682 151.426C341.461 146.776 347.511 144.452 354.833 144.452C362.154 144.452 368.154 146.776 372.831 151.426C377.611 155.974 380 161.837 380 169.013C380 176.189 377.611 182.102 372.831 186.752ZM354.833 180.233C356.968 180.233 358.9 179.778 360.629 178.868C362.358 177.857 363.68 176.493 364.595 174.774C365.612 173.056 366.12 171.136 366.12 169.013C366.12 165.678 365.052 162.949 362.917 160.826C360.883 158.703 358.188 157.642 354.833 157.642C353.206 157.642 351.681 157.945 350.257 158.552C348.833 159.158 347.613 159.967 346.596 160.978C345.681 161.887 344.918 163.05 344.308 164.465C343.698 165.88 343.393 167.396 343.393 169.013C343.393 172.248 344.461 174.926 346.596 177.049C348.833 179.171 351.579 180.233 354.833 180.233Z'
                    fill='white'
                />
            </svg>
        ) : (
            <svg
                width='191'
                height='99'
                viewBox='0 0 191 99'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M40.75 37.4014C48.1786 38.7338 54.1309 42.1123 58.6071 47.537C63.1785 52.9616 65.4643 59.4331 65.4643 66.9514C65.4643 76.0877 62.3214 83.6536 56.0357 89.6493C49.8452 95.5498 42.0833 98.5 32.75 98.5C23.7024 98.5 16.1786 95.6925 10.1786 90.0775C4.27381 84.3674 1.13095 77.0394 0.75 68.0935H16.1786C16.4643 72.8519 18.1309 76.7063 21.1786 79.6565C24.2262 82.5116 28.0833 83.9391 32.75 83.9391C37.7024 83.9391 41.7976 82.3213 45.0357 79.0855C48.2738 75.7546 49.8928 71.5671 49.8928 66.5232C49.8928 64.0488 49.4166 61.7647 48.4643 59.671C47.5119 57.4821 46.2262 55.6263 44.6071 54.1036C42.9881 52.5809 41.0357 51.4389 38.75 50.6775C36.4643 49.821 33.9881 49.3928 31.3214 49.3928H19.3214V46.3949L39.0357 15.8457H3.60714V1.8558H61.75V4.99638L40.75 37.4014Z'
                    fill='white'
                />
                <path
                    d='M92.8214 82.2261H128.25V96.787H63.25V92.6471C77.4404 77.1346 87.6785 65.5715 93.9642 57.958C100.345 50.2493 104.583 44.3964 106.679 40.3993C108.774 36.4022 109.821 32.4527 109.821 28.5507C109.821 25.7908 109.202 23.364 107.964 21.2703C106.821 19.1766 105.155 17.5587 102.964 16.4167C100.869 15.1795 98.3928 14.5609 95.5357 14.5609C91.0595 14.5609 87.4404 15.8932 84.6785 18.558C82.0119 21.1275 80.6785 24.506 80.6785 28.6935V30.8348H65.25V28.6935C65.25 20.1283 68.0119 13.2285 73.5357 7.9942C79.0595 2.66473 86.3452 0 95.3928 0C104.25 0 111.44 2.66473 116.964 7.9942C122.583 13.3237 125.393 20.1758 125.393 28.5507C125.393 32.9285 124.583 37.1635 122.964 41.2558C121.44 45.3481 118.298 50.6299 113.536 57.1014C108.869 63.4778 101.964 71.8527 92.8214 82.2261Z'
                    fill='white'
                />
                <path
                    d='M144.839 66.5412C141.127 66.5412 138.077 65.3789 135.687 63.0541C133.348 60.7294 132.179 57.7476 132.179 54.1089C132.179 50.5207 133.348 47.5895 135.687 45.3153C138.077 42.9905 141.127 41.8281 144.839 41.8281C148.55 41.8281 151.575 42.9905 153.914 45.3153C156.253 47.5895 157.422 50.5207 157.422 54.1089C157.422 57.7476 156.228 60.7294 153.838 63.0541C151.499 65.3789 148.499 66.5412 144.839 66.5412ZM140.263 96.7125L172.675 43.2685H181.598L149.186 96.7125H140.263ZM144.839 59.8702C145.652 59.8702 146.415 59.7439 147.127 59.4912C147.838 59.1879 148.449 58.7836 148.957 58.2783C149.465 57.7729 149.847 57.1664 150.101 56.4589C150.406 55.7514 150.559 54.968 150.559 54.1089C150.559 52.4917 150.025 51.1524 148.957 50.0911C147.889 48.9793 146.517 48.4233 144.839 48.4233C143.212 48.4233 141.839 48.9793 140.72 50.0911C139.653 51.1524 139.119 52.4917 139.119 54.1089C139.119 55.7766 139.653 57.1664 140.72 58.2783C141.839 59.3396 143.212 59.8702 144.839 59.8702ZM187.166 93.3769C184.827 95.6512 181.827 96.7883 178.166 96.7883C174.506 96.7883 171.481 95.6512 169.091 93.3769C166.752 91.0522 165.583 88.0957 165.583 84.5075C165.583 80.9193 166.752 77.9881 169.091 75.7139C171.481 73.3891 174.506 72.2268 178.166 72.2268C181.827 72.2268 184.827 73.3891 187.166 75.7139C189.555 77.9881 190.75 80.9193 190.75 84.5075C190.75 88.0957 189.555 91.0522 187.166 93.3769ZM178.166 90.1172C179.234 90.1172 180.2 89.8898 181.064 89.435C181.929 88.9296 182.59 88.2473 183.047 87.3882C183.556 86.529 183.81 85.5688 183.81 84.5075C183.81 82.8398 183.276 81.4752 182.208 80.4139C181.192 79.3526 179.844 78.822 178.166 78.822C177.353 78.822 176.59 78.9736 175.878 79.2768C175.167 79.5801 174.557 79.9844 174.048 80.4897C173.591 80.9446 173.209 81.5258 172.904 82.2333C172.599 82.9408 172.447 83.6989 172.447 84.5075C172.447 86.1247 172.98 87.464 174.048 88.5253C175.167 89.5866 176.539 90.1172 178.166 90.1172Z'
                    fill='white'
                />
            </svg>
        )}
    </>
)

export const ThirdSlideSvg = ({ isMobile }: { isMobile: boolean }) => (
    <>
        {!isMobile ? (
            <img
                src='/pangram.svg'
                style={{ filter: 'invert(1)', height: '197px', width: 139 }}
                alt='gdfgdfgdfg'
            />
        ) : (
            <img
                src='/pangram.svg'
                style={{ filter: 'invert(1)', height: '110px', width: 80 }}
                alt='gdfgdfgdfg'
            />
        )}
        {/* {!isMobile ? */}
        {/* // <p style={{fontSize: 250, marginBlockStart: '0', marginBlockEnd: 0, fontWeight: 600, letterSpacing: 0, lineHeight: 1, color: "white"}}>6</p> */}
        {/* : */}
        {/* // <p style={{fontSize: 180, marginBlockStart: '0', marginBlockEnd: 0, fontWeight: 600, letterSpacing: 0, lineHeight: 1, color: "white"}}>6</p> */}
        {/* } */}
        {/* {!isMobile ? (
            <svg
                width='80'
                height='119'
                viewBox='0 0 80 119'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M38.4289 41.7999C50.3069 41.7999 60.0299 45.4144 67.5989 52.6434C75.2849 59.8724 79.1279 68.9086 79.1279 79.7521C79.1279 90.8287 75.3429 100.039 67.7739 107.385C60.2049 114.731 50.7719 118.403 39.4769 118.403C28.2979 118.403 18.9815 114.906 11.5287 107.91C4.19234 100.914 0.349537 91.9947 0.000236511 81.1512H18.8651C19.098 86.8645 21.1359 91.5283 24.9789 95.1428C28.8219 98.7574 33.6539 100.564 39.4769 100.564C45.4159 100.564 50.3069 98.5824 54.1499 94.6181C58.1089 90.6539 60.0879 85.6985 60.0879 79.7521C60.0879 77.7699 59.7969 75.8461 59.2149 73.9805C58.7489 72.115 58.0509 70.4243 57.1189 68.9086C56.1869 67.2762 55.0229 65.8188 53.6249 64.5362C52.3449 63.2537 50.8889 62.146 49.2589 61.2132C47.6279 60.2804 45.8229 59.5809 43.8439 59.1145C41.9799 58.6481 39.9429 58.4149 37.7299 58.4149H4.51933L4.71644 55.7915L11.0047 0H71.0929V17.1397H26.2019L23.5809 41.7999H38.4289Z'
                    fill='white'
                />
            </svg>
        ) : (
            <svg
                width='80'
                height='119'
                viewBox='0 0 80 119'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    d='M38.4289 41.7999C50.3069 41.7999 60.0299 45.4144 67.5989 52.6434C75.2849 59.8724 79.1279 68.9086 79.1279 79.7521C79.1279 90.8287 75.3429 100.039 67.7739 107.385C60.2049 114.731 50.7719 118.403 39.4769 118.403C28.2979 118.403 18.9815 114.906 11.5287 107.91C4.19234 100.914 0.349537 91.9947 0.000236511 81.1512H18.8651C19.098 86.8645 21.1359 91.5283 24.9789 95.1428C28.8219 98.7574 33.6539 100.564 39.4769 100.564C45.4159 100.564 50.3069 98.5824 54.1499 94.6181C58.1089 90.6539 60.0879 85.6985 60.0879 79.7521C60.0879 77.7699 59.7969 75.8461 59.2149 73.9805C58.7489 72.115 58.0509 70.4243 57.1189 68.9086C56.1869 67.2762 55.0229 65.8188 53.6249 64.5362C52.3449 63.2537 50.8889 62.146 49.2589 61.2132C47.6279 60.2804 45.8229 59.5809 43.8439 59.1145C41.9799 58.6481 39.9429 58.4149 37.7299 58.4149H4.51933L4.71644 55.7915L11.0047 0H71.0929V17.1397H26.2019L23.5809 41.7999H38.4289Z'
                    fill='white'
                />
            </svg>
        )} */}
    </>
)

const SlideInner = ({
    v,
    upperText,
    centerText,
    descriptionText,
    videosLength,
    isCurrentSlideActive,
    activeSlideIndex,
    buttonText,
    buttonLink
}: {
    isMobile: boolean
    v: string
    upperText: string
    centerText: string
    descriptionText: string
    videosLength: number
    activeSlideIndex: number
    isCurrentSlideActive: boolean
    buttonText?: string
    buttonLink?: string
}) => {
    const [isLoaded, setIsLoaded] = useState(false)

    const { t } = useTranslation()
    const router = useRouter()

    return (
        <>
            {!isLoaded ? <div className={s.skel}></div> : ''}{' '}
            <div
                style={{ opacity: isCurrentSlideActive ? 1 : 0.5, transition: 'ease-in-out 0.3s' }}
                className={s.slide}
            >
                <div className={s.progress}>
                    {Array.from({ length: videosLength }).map((_, index) => {
                        return (
                            <div
                                className={classNames(s.progressItem, { [s.active]: activeSlideIndex === index })}
                            ></div>
                        )
                    })}
                </div>
                <div className={s.header}>
                    <div>
                        <h2
                            className={`${s.upperText}`}
                            dangerouslySetInnerHTML={{ __html: upperText }}
                        ></h2>
                    </div>
                    <p
                        className={s.text}
                        dangerouslySetInnerHTML={{ __html: centerText }}
                    ></p>
                </div>
                <div className={s.footer}>
                    <div className={s.footer_header}>
                        <span className={s.header}>{t('Megamix')}</span>
                        <div className={s.desc}>{descriptionText}</div>
                    </div>
                    <div className={s.buttons}>
                        <div className={s.slide_buttons}>
                            <button
                                onClick={() => {
                                    router.push(buttonLink ? buttonLink : '/catalog')
                                }}
                            >
                                <p>{buttonText ? buttonText : t('catalog')}</p>
                            </button>

                            <button
                                onClick={() => {
                                    router.push('/b2b')
                                }}
                            >
                                <p>{t('aboutCompany')}</p>
                            </button>
                        </div>
                        <div className={s.slider_buttons}>
                            <PreviousButton />
                            <NextButton />
                        </div>
                    </div>
                </div>
                <video
                    playsInline
                    autoPlay={true}
                    onLoadedData={() => setIsLoaded(true)}
                    muted={true}
                    loop={true}
                    style={{ maxWidth: '1235px' }}
                    className={s.video}
                >
                    <source
                        src={`/${v}.webm`}
                        type='video/webm'
                    />
                    <source
                        src={`/${v}.mp4`}
                        type='video/mp4'
                    />
                </video>
            </div>
        </>
    )
}

const SliderPageThreeTest = () => {
    const isLaptop = useMediaQuery('(max-width: 1250px)')
    const isMobile = useMediaQuery('(max-width: 750px) or (orientation: portrait)')
    const isDesktop = useMediaQuery('(min-width: 1251px)')
    const [activeSlideIndex, setActiveSlideIndex] = useState<number>(0)
    const { t } = useTranslation()
    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        const set = () => setIsLoaded(prev => !prev)
        document.addEventListener('DOMContentLoaded', set)
        document.addEventListener('resize', set)
        return () => {
            document.addEventListener('resize', set)
            document.removeEventListener('DOMContentLoaded', set)
        }
    }, [])

    const videos = [
        {
            video: '32',
            upperText: '32%',
            centerText: t('ourPremix'),
            descriptionText: t('leaderText')
        },
        {
            video: 'GMP',
            upperText: 'GMP+<br/>FSA',
            centerText: t('systemAndControl'),
            descriptionText: t('controlText')
        },
        {
            video: '60',
            upperText: '60+',
            centerText: t('Products'),
            descriptionText: t('expert'),
            buttonText: t('consulting'),
            buttonLink: '/consulting'
        },
        {
            video: '150000',
            upperText: '>150 000',
            centerText: t('unique'),
            descriptionText: t('innovation'),
            buttonText: t('laboratories'),
            buttonLink: '/labs'
        },
        {
            video: '2000',
            upperText: '2 000+',
            centerText: t('employee'),
            descriptionText: t('perspective'),
            buttonText: t('vacancy'),
            buttonLink: '/vacancy'
        },
        {
            video: '6',
            upperText: '6',
            centerText: t('animal'),
            descriptionText: t('partner')
        }
    ]

    return (
        <div className={s.content}>
            {isDesktop ? (
                <Swiper
                    spaceBetween={30}
                    effect={'coverflow'}
                    key={'desktop'}
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={'auto'}
                    autoplay={{
                        pauseOnMouseEnter: false,

                        delay: 5000
                    }}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: -200,
                        depth: 300,
                        modifier: 2.5
                    }}
                    modules={[Autoplay, EffectCoverflow, Pagination, Navigation]}
                    className={s.swiperWrapper}
                    onActiveIndexChange={swiper => setActiveSlideIndex(swiper.activeIndex)}
                >
                    {videos.map((v, i) => (
                        <SwiperSlide
                            key={i}
                            style={{ borderRadius: 12 }}
                        >
                            <SlideInner
                                buttonLink={v.buttonLink}
                                buttonText={v.buttonText}
                                videosLength={videos.length}
                                isCurrentSlideActive={activeSlideIndex === i}
                                activeSlideIndex={activeSlideIndex}
                                descriptionText={v.descriptionText}
                                v={v.video}
                                isMobile={isMobile}
                                upperText={v.upperText}
                                centerText={v.centerText}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <>
                    {isLaptop && !isMobile ? (
                        <Swiper
                            spaceBetween={30}
                            effect={'coverflow'}
                            grabCursor={true}
                            key={'laptop'}
                            centeredSlides={true}
                            slidesPerView={'auto'}
                            autoplay={{
                                pauseOnMouseEnter: false,
                                delay: 5000
                            }}
                            coverflowEffect={{
                                rotate: 0,
                                stretch: -170,
                                depth: 100,
                                modifier: 2.5
                            }}
                            modules={[Autoplay, EffectCoverflow, Pagination, Navigation]}
                            onActiveIndexChange={swiper => setActiveSlideIndex(swiper.activeIndex)}
                            className={s.swiperWrapper}
                        >
                            {videos.map((v, i) => (
                                <SwiperSlide
                                    key={i}
                                    style={{ borderRadius: 12 }}
                                    className={s.swiper_slide}
                                >
                                    <SlideInner
                                        buttonLink={v.buttonLink}
                                        buttonText={v.buttonText}
                                        videosLength={videos.length}
                                        isCurrentSlideActive={activeSlideIndex === i}
                                        activeSlideIndex={activeSlideIndex}
                                        descriptionText={v.descriptionText}
                                        v={v.video}
                                        isMobile={isMobile}
                                        upperText={v.upperText}
                                        centerText={v.centerText}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    ) : (
                        <Swiper
                            spaceBetween={30}
                            effect={'coverflow'}
                            grabCursor={true}
                            key={'mobile'}
                            centeredSlides={true}
                            slidesPerView={'auto'}
                            autoplay={{
                                pauseOnMouseEnter: false,
                                delay: 5000
                            }}
                            coverflowEffect={{
                                rotate: 0,
                                stretch: -5,
                                depth: 100,
                                modifier: 2.5
                            }}
                            modules={[Autoplay, EffectCoverflow, Pagination, Navigation]}
                            onActiveIndexChange={swiper => setActiveSlideIndex(swiper.activeIndex)}
                            className={s.swiperWrapper}
                        >
                            {videos.map((v, i) => (
                                <SwiperSlide
                                    key={i}
                                    style={{ borderRadius: 12 }}
                                    className={s.swiper_slide}
                                >
                                    <SlideInner
                                        buttonLink={v.buttonLink}
                                        buttonText={v.buttonText}
                                        videosLength={videos.length}
                                        isCurrentSlideActive={activeSlideIndex === i}
                                        activeSlideIndex={activeSlideIndex}
                                        descriptionText={v.descriptionText}
                                        v={v.video}
                                        isMobile={isMobile}
                                        upperText={v.upperText}
                                        centerText={v.centerText}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}
                </>
            )}
        </div>
    )
}

export default SliderPageThreeTest
